
import { defineComponent, ref, reactive, toRefs, watch, onMounted } from 'vue'
import { DoubleRightOutlined, InfoCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Nodata from '@/components/page/nodata.vue'
import Navatop from '@/components/navtop.vue'
import globalsets from '@/utils/globalsets'
import f10Api from '@/api/f10Api'
export default defineComponent({
  components: { InfoCircleOutlined, Nodata },
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      currentData: {},
      tags1: [],
      tags2: [],
      activeTagVal1: 1,
      activeTagVal2: null
    })
    pageData.tags1 = [
      {
        label: '按报告期',
        value: 1
      },
      {
        label: '按年度',
        value: 2
      }
    ]
    watch(
      () => (props.pageSourceData || {}).Dupont,
      (val: any) => {
        const data = JSON.parse(JSON.stringify(val))
        const tags: any = []
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'Dupont' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
            tags.push({
              label: item.time,
              value: item.time
            })
          })
        }
        pageData.data = data
        pageData.tags2 = tags
        pageData.activeTagVal2 = (pageData.tags2[0] || {}).value
        pageData.currentData = (pageData.data || [])[0] || {}
      }
    )
    const getNumber = globalsets.getNumber
    function checkTag1(tag: any) {
      pageData.activeTagVal1 = tag.value
      getDetail(pageData.activeTagVal1)
    }
    function checkTag2(tag: any) {
      pageData.activeTagVal2 = tag.value
      pageData.currentData = (pageData.data || []).filter((item: any) => item.time === pageData.activeTagVal2)[0]
    }
    const route = useRoute()
    function getDetail(type: number) {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        StaticsType: type,
        DataType: 4
      }
      data.headers = {
        token: props.token
      }
      f10Api.getFinanceF10(data).then((res: any) => {
        const data = JSON.parse(JSON.stringify((res.Data || {}).Dupont))
        const tags: any = []
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'Dupont' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
            tags.push({
              label: item.time,
              value: item.time
            })
          })
        }
        pageData.data = data
        pageData.tags2 = tags
        pageData.activeTagVal2 = pageData.tags2[0].value
        pageData.currentData = (pageData.data || [])[0] || {}
      })
    }
    return {
      ...toRefs(pageData),
      checkTag1,
      checkTag2,
      getNumber
    }
  }
})
